import state from "./findings.state";
import actions from "./findings.actions";

export default {
  namespaced: true,
  state,
  actions,
};
